/**
 * @generated SignedSource<<27f0cca9672351409f03d061aef57975>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubblesWrapper_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbles_viewer">;
  readonly " $fragmentType": "PdpRespIconBubblesWrapper_viewer";
};
export type PdpRespIconBubblesWrapper_viewer$key = {
  readonly " $data"?: PdpRespIconBubblesWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubblesWrapper_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubblesWrapper_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbles_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2536db58eb5d34fceb53eb67fb05f47c";

export default node;
